import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex-grow: 1;\n  margin-bottom: 60px;\n\n  @media (max-width: 768px) {\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.14px;\n\n  .required {\n    margin: 0 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  margin-left: 4px;\n  color: ",
        ";\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: -0.14px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLibrarySubject } from "@/modules/mypages/libraries/components";
import { CLASS_INDEX_PAGE } from "@/settings/constant";
import { useMutation } from "@tanstack/react-query";
import { message } from "antd";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { postClass } from "src/api/class";
import useClassStore from "src/store/class";
import styled from "styled-components";
import { ModalTitle, NewClassActionsContainer, TextField } from ".";
import FilledButton from "../common/Button/FilledButton";
const NewClassForm = styled.form.withConfig({
    componentId: "sc-745fa1a3-0"
})(_templateObject());
const NewClassStep1 = (param)=>{
    let { onCancel  } = param;
    const { name , isWithSelected  } = useClassStore((state)=>state.adding);
    const selected = useClassStore((state)=>state.selected);
    const { setAdding , closeNewClass  } = useClassStore((param)=>{
        let { setAdding , closeNewClass  } = param;
        return {
            setAdding,
            closeNewClass
        };
    });
    const { push  } = useRouter();
    const subject = useLibrarySubject();
    const classMutation = useMutation(postClass);
    const handleSubmit = useCallback(async (e)=>{
        e.preventDefault();
        if (name.length >= 3) {
            if (isWithSelected) {
                const cls = await classMutation.mutateAsync({
                    name,
                    subject,
                    choices: Object.entries(selected).map((param)=>{
                        let [k, v] = param;
                        return {
                            sourceId: k,
                            sourceType: v
                        };
                    })
                });
                closeNewClass();
                message.info("클래스가 생성됐어요.");
                push(CLASS_INDEX_PAGE.concat("/".concat(cls.id)));
            } else {
                setAdding({
                    step: 2
                });
            }
        } else {
            message.warning("클래스 이름은 최소 3글자입니다.");
        }
    }, [
        name,
        setAdding,
        isWithSelected,
        classMutation,
        subject,
        selected,
        push,
        closeNewClass
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(NewClassForm, {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ _jsx(NewClassName, {}),
                /*#__PURE__*/ _jsxs(NewClassActionsContainer, {
                    children: [
                        /*#__PURE__*/ _jsx(FilledButton, {
                            type: "text",
                            variant: "soft",
                            onClick: onCancel,
                            children: "취소"
                        }),
                        /*#__PURE__*/ _jsx(FilledButton, {
                            type: "text",
                            variant: "solid",
                            disabled: !name.length,
                            htmlType: "submit",
                            children: "다음"
                        })
                    ]
                })
            ]
        })
    });
};
export default NewClassStep1;
const NewClassNameFieldset = styled.fieldset.withConfig({
    componentId: "sc-745fa1a3-1"
})(_templateObject1());
const NewClassNameLegend = styled.legend.withConfig({
    componentId: "sc-745fa1a3-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_900, (props)=>props.theme.new.colors.sol_mint_400);
const NewClassHelperText = styled.p.withConfig({
    componentId: "sc-745fa1a3-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_gray_500);
const NewClassName = ()=>{
    const { name  } = useClassStore((state)=>state.adding);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(ModalTitle, {
                children: [
                    "새 ",
                    /*#__PURE__*/ _jsx("strong", {
                        children: "클래스 이름"
                    }),
                    "을",
                    /*#__PURE__*/ _jsx("br", {}),
                    "입력해주세요."
                ]
            }),
            /*#__PURE__*/ _jsxs(NewClassNameFieldset, {
                children: [
                    /*#__PURE__*/ _jsxs(NewClassNameLegend, {
                        children: [
                            "클래스 이름",
                            /*#__PURE__*/ _jsx("span", {
                                className: "required",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(TextField, {
                        placeholder: "예비 고2 선행반",
                        name: "name",
                        value: name,
                        maxLength: 10
                    }),
                    /*#__PURE__*/ _jsx(NewClassHelperText, {
                        children: "클래스 이름은 최대 10글자입니다."
                    })
                ]
            })
        ]
    });
};
